import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IUserContactGroup } from '../../../store/models/user-group.model';
import { EMenuButtonItemType, IMenuButtonProperties } from '../../../store/models/menu-button.model';

@Component({
  selector: 'app-user-groups-listing-mobile-row',
  templateUrl: './user-group-listing-mobile-row.component.html',
  styleUrls: ['./user-group-listing-mobile-row.component.scss'],
})
export class UserGroupListingMobileRowComponent implements OnInit {

  @Input() item: IUserContactGroup;

  @Output() manage: EventEmitter<IUserContactGroup> = new EventEmitter<IUserContactGroup>();
  @Output() send: EventEmitter<IUserContactGroup> = new EventEmitter<IUserContactGroup>();

  menuItems: IMenuButtonProperties = {
    items: [
      {
        label: 'Manage',
        type: EMenuButtonItemType.BUTTON,
        onClick: (target: IUserContactGroup) => this.manage.emit(target),
      },
      {
        label: 'Send to campaign',
        type: EMenuButtonItemType.BUTTON,
        onClick: (target: IUserContactGroup) => this.send.emit(target),
      },
    ],
  };

  constructor() {
  }

  ngOnInit(): void {
  }

}
